import { render, staticRenderFns } from "./select-envelope-type.vue?vue&type=template&id=77332cce&scoped=true&"
import script from "./select-envelope-type.vue?vue&type=script&lang=js&"
export * from "./select-envelope-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77332cce",
  null
  
)

export default component.exports